<div class="line-loading-container">
    <div class="line-loading-block" [ngStyle]="{'width.%':currentValue}"></div>
</div>